import isToday from 'date-fns/isToday'

export function isAppointmentToday(start_time) {
  return isToday(new Date(`${start_time}Z`))
}
